import type { RouteRecordRaw } from "vue-router";
import CanvassAreaPage from "./CanvassAreaPage.vue";
import CanvassBottomNav from "./CanvassBottomNav.vue";
import CanvassConversationGuidePage from "./CanvassConversationGuidePage.vue";
import CanvassEditContactPage from "./CanvassEditContactPage.vue";
import CanvassFlowLayout from "./CanvassFlowLayout.vue";
import CanvassHouseCommentsPage from "./CanvassHouseCommentsPage.vue";
import CanvassHouseContactsPage from "./CanvassHouseContactsPage.vue";
import CanvassHouseConversationsPage from "./CanvassHouseConversationsPage.vue";
import CanvassHouseDetailsPage from "./CanvassHouseDetailsPage.vue";
import CanvassHouseEditConversationPage from "./CanvassHouseEditConversationPage.vue";
import CanvassHouseLayout from "./CanvassHouseLayout.vue";
import CanvassNewContactPage from "./CanvassNewContactPage.vue";
import CanvassNewConversationPage from "./CanvassNewConversationPage.vue";
import CanvassOverviewPage from "./CanvassOverviewPage.vue";
import CanvassSupportPage from "./CanvassSupportPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/canvass-flow/:canvassId",
    name: "canvassFlow",
    component: CanvassFlowLayout,
    props: (route) => ({ canvassId: route.params.canvassId }),
    children: [
      {
        path: "",
        name: "canvassFlowOverview",
        components: {
          default: CanvassOverviewPage,
          nav: CanvassBottomNav,
        },
      },
      {
        path: "map",
        name: "canvassFlowArea",
        components: {
          default: CanvassAreaPage,
          nav: CanvassBottomNav,
        },
        children: [
          {
            path: "houses/:houseId",
            name: "canvassFlowHouse",
            component: CanvassHouseLayout,
            props: (route) => ({
              houseId: parseInt(route.params.houseId as string, 10),
            }),
            children: [
              {
                path: "",
                name: "canvassFlowHouseDetails",
                component: CanvassHouseDetailsPage,
              },
              {
                path: "contacts",
                name: "canvassFlowHouseContacts",
                component: CanvassHouseContactsPage,
              },
              {
                path: "conversations",
                name: "canvassFlowHouseConversations",
                component: CanvassHouseConversationsPage,
              },
              {
                path: "comments",
                name: "canvassFlowHouseComments",
                component: CanvassHouseCommentsPage,
              },
            ],
          },
        ],
      },
      {
        path: "conversation-guide",
        name: "canvassFlowConversationGuide",
        components: {
          default: CanvassConversationGuidePage,
          nav: CanvassBottomNav,
        },
      },
      {
        path: "support",
        name: "canvassFlowSupport",
        components: {
          default: CanvassSupportPage,
          nav: CanvassBottomNav,
        },
      },
      {
        path: "houses/:houseId/contacts/new",
        name: "canvassFlowNewContact",
        component: CanvassNewContactPage,
        props: (route) => ({
          houseId: parseInt(route.params.houseId as string, 10),
        }),
      },
      {
        path: "houses/:houseId/contacts/:contactId",
        name: "canvassFlowEditContact",
        component: CanvassEditContactPage,
        props: (route) => ({ contactId: route.params.contactId }),
      },
      {
        path: "houses/:houseId/conversations/new",
        name: "canvassFlowNewConversation",
        component: CanvassNewConversationPage,
        props: (route) => ({
          houseId: parseInt(route.params.houseId as string, 10),
        }),
      },
      {
        path: "houses/:houseId/conversations/:conversationId",
        name: "canvassFlowEditConversation",
        component: CanvassHouseEditConversationPage,
        props: (route) => ({
          houseId: parseInt(route.params.houseId as string, 10),
          conversationId: route.params.conversationId,
        }),
      },
    ],
  },
];

export default routes;
